import { render } from "./App.vue?vue&type=template&id=0840c813"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0840c813&lang=less"

import exportComponent from "/Users/summer/Desktop/code/study_mp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__